import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { routing } from './login.routing';

// pages
import { LoginPageComponent } from '../../../pages/login/login.component';

// components
import { LoginComponent } from '../../../components/login/login.component';
import { LoginSCAComponent } from '../../../components/login-sca/login-sca.component';
import { LeftSideDescriptions } from '../../../components/login-sca/left-side-descriptions/left-side-descriptions.component';
import { CallLoadingScreenComponent } from '../../../components/login-sca/call-loading-screen/call-loading-screen.component';
import { UsernameComponent } from '../../../components/login-sca/username/username.component';

// component modules
import { CommonComponentsModule } from '../../components/common/common.module';
import { LoadingModule } from '../../../modules/components/loading/loading.module';
import { PasscodeModule } from '../../../modules/components/passcode/passcode.module';
import { TabsModule } from '../../../modules/components/tabs/tabs.module';
import { CommonLoggedOutComponentsModule } from '../../../modules/components/common-logged-out/common-logged-out.module';
import { ValidationMessagesModule } from '../../../modules/components/validation-messages/validation-messages.module';
import { UplBannerComponent } from '../../../components/upl-banner/upl-banner.component';
import { ExpanderModule } from '../../../modules/components/expander/expander.module';
import { SystemNotificationsModule } from '../../../components/system-notifications/system-notifications.module';

// services
import { ShowSecretToggleModule } from '../../components/show-secret-toggle/show-secret-toggle.module';
import { NonSCAStoreStaffCardsService } from '../../../services/strong-customer-authentication/non-SCA-store-staff-cards.service';

// directives
import { InvalidInputFocusDirectiveModule } from '../../../modules/directives/invalidInputFocusDirective/invalidInputFocusDirective.module';
import { StrongCustomerAuthenticationModule } from '../../components/strong-customer-authentication/strong-customer-authentication.module';
import { CompatibilityModule } from '../../components/compatibility/compatibility.module';

@NgModule({
  declarations: [
    LoginPageComponent,
    LoginComponent,
    LoginSCAComponent,
    UplBannerComponent,
    LeftSideDescriptions,
    CallLoadingScreenComponent,
    UsernameComponent,
  ],
  imports: [
    routing,
    CommonModule,
    CommonComponentsModule,
    FormsModule,
    LoadingModule,
    PasscodeModule,
    ReactiveFormsModule,
    ShowSecretToggleModule,
    TabsModule,
    CommonLoggedOutComponentsModule,
    ValidationMessagesModule,
    InvalidInputFocusDirectiveModule,
    ExpanderModule,
    StrongCustomerAuthenticationModule,
    SystemNotificationsModule,
    CompatibilityModule,
  ],
  providers: [CookieService, NonSCAStoreStaffCardsService],
})
export class LoginModule {}
